import { Chapter } from "@/models/chapter.model";
import { Course } from "@/models/courses.model";
import { QueryParams } from "@/models/query-params.model";
import { CategoriesRest } from "@/services/rest/categories.rest";
import { ChaptersRest } from "@/services/rest/chapters.rest";
import { CoursesRest } from "@/services/rest/courses.rest";
import { GenericsUtils } from "@/utils/generics.util";
import { getUserFromStorage } from "@/utils/user-store.util";
import { BehaviorSubject, map, Observable, take } from "rxjs";

export class CourseService {
  constructor(
    private _courses = new CoursesRest(),
    private _chapters = new ChaptersRest(),
    private _categories = new CategoriesRest(),
    private _generics = new GenericsUtils()
  ) {}

  private courses$: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  courses: Observable<Course> = this.courses$.asObservable();
  private heroH5p$: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  heroH5p: Observable<Course> = this.heroH5p$.asObservable();

  private course$ = new BehaviorSubject<Course>(new Course());
  course = this.course$.asObservable();

  private chapter$: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  chapter: Observable<Chapter> = this.chapter$.asObservable();

  private categories$: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  categories: Observable<any> = this.categories$.asObservable();

  getCoursesById(courseId: string, baseUrl?: string): void {
    this._courses
      .getCoursesById(courseId, baseUrl!)
      .pipe(
        map((e) => {
          e.duration = this._generics.formatTime(e.duration);
          return e;
        })
      )
      .subscribe((response) => this.course$.next(response));
  }

  getHeroH5p(courseId: string): void {
    this._courses
      .getCoursesById(courseId, "/api")
      .pipe(
        map((e) => {
          e.duration = this._generics.formatTime(e.duration);
          return e;
        })
      )
      .subscribe((response) => this.heroH5p$.next(response));
  }

  getCourseTraditional(courseId: string): void {
    this._courses.getCourseTraditional(courseId).subscribe((response) => {
      this.course$.next(response);
    });
  }

  getCategories(params: QueryParams): void {
    this._categories
      .getCategories(params)
      .pipe(take(1))
      .subscribe({
        next: (response) => {
          this.categories$.next(response.content);
        },
      });
  }

  getChapterById(courseId: string, chapterId: string): void {
    this._chapters
      .getChapterById(courseId, chapterId)
      .pipe(take(1))
      .subscribe({
        next: (response) => {
          this.chapter$.next(response);
        },
      });
  }

  getCourses(queryParams: QueryParams): void {
    this._courses
      .getCourses(queryParams)
      .pipe(take(1))
      .subscribe((response) => this.courses$.next(response));
  }
}
